var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export-section"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.disabled,"loading":_vm.loading,"size":"medium"},on:{"click":_vm.exportData}},[_vm._v("Export CSV")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }